<template>
  <v-dialog v-model="visible" persistent max-width="1600px">
    <v-card>
      <v-card-title class="text-uppercase">{{ titulo }}</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form>
          <v-row style="padding-bottom: 0px !important">
            <v-col cols="12" md="5" lg="4">
              <v-select
                :items="categoriasItems"
                label="Categorias"
                item-text="text"
                item-value="value"
                v-model="categoria"
                required
                placeholder=" "
                outlined
                dense
                :item-disabled="(item) => item.desactivado"
                @change="getCategoriaChange"
                hide-details />
              <small v-for="error in errores.mes" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="form.nombre_programa"
                label="Nombre del Programa"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
              <small v-for="error in errores.nombre_programa" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                v-model="form.cantidad_inscritos_estimada"
                label="Cantidad Inscritos"
                type="number"
                @change="changecantidadIncritosEstimada()"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.cantidad_inscritos_estimada" :key="error" class="text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                label="Nro de Cuotas"
                v-model="form.numero_cuotas"
                @change="changecantidadIncritosEstimada()"
                type="number"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.numero_cuotas" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="9" lg="4">
              <v-row style="padding-bottom: 0px !important">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.fecha_inicio"
                    label="Fecha Inicio"
                    :min="`${gestion?.numero}-01-01`"
                    :max="`${gestion?.numero}-12-31`"
                    placeholder=" "
                    @change="changecantidadIncritosEstimada()"
                    type="date"
                    outlined
                    dense
                    hide-details></v-text-field>
                  <small v-for="error in errores.fecha_inicio" :key="error" class="text-danger">{{ error }}</small>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    :disabled="form.fecha_inicio == ''"
                    v-model="form.fecha_segunda"
                    label="Fecha Segunda"
                    :min="fechaMinSegunda"
                    placeholder=" "
                    @change="changecantidadIncritosEstimada()"
                    type="date"
                    outlined
                    dense
                    hide-details></v-text-field>
                  <small v-for="error in errores.fecha_segunda" :key="error" class="text-danger">{{ error }}</small>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    :value="(form.fecha_fin = fechaFin)"
                    label="Fecha Fin"
                    placeholder=" "
                    type="date"
                    outlined
                    disabled
                    dense
                    hide-details></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                v-model="form.tasa_desercion"
                label="Tasa de desercion %"
                type="number"
                @change="changecantidadIncritosEstimada()"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>

              <small v-for="error in errores.tasa_desercion" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                :value="estudiantes_desertores"
                label="Cantidad Desercion"
                disabled
                type="number"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                v-model="form.porcentaje_contado"
                label="Porcentaje Contado %"
                type="number"
                @change="changecantidadIncritosEstimada()"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
              <small v-for="error in errores.porcentaje_contado" :key="error" class="text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="3" lg="2">
              <v-text-field
                :value="estudiantes_contado"
                label="Cantidad Contado"
                disabled
                type="number"
                placeholder=" "
                outlined
                dense
                hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text>
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-balham ag-grid-table-presupuesto-partida"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          @grid-ready="onGridReady"
          :rowData="form.detalles_estimaciones"
          :suppressRowClickSelection="true"
          colResizeDefault="shift"
          :animateRows="true"
          :rowClassRules="rowClassRules"
          :pinnedBottomRowData="pinnedBottomRowData"
          @rowClicked="onRowClicked($event)"
          :alwaysShowVerticalScroll="true"
          @first-data-rendered="onFirstDataRendered">
        </ag-grid-vue>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="validar()"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import 'vue-select/dist/vue-select.css';
import IngresoServices from '../services/ingresos';
import moment from 'moment';
import AgGridMixin from '../mixins/ag-grid-mixin';
import ModalFormMixin from '../mixins/modal-form-mixin';
import {
  ACCIONES_CRUD,
  aMonedaValueFormatter,
  CATEGORIAS,
  conceptosNoPagablesSiEsContado,
  conceptosPagosCertificacion,
  conceptosPagosRecurrentes,
  CONCEPTOS_PAGOS,
  formatearErrores,
  formatearValorAMoneda,
  UNIDADES_NEGOCIOS,
} from '../utils';
import CabeceraAgGridPersonalizada from './CabeceraAgGridPersonalizada.vue';

export default {
  name: 'ModalFormPresupuestoIngresoGestion',
  mixins: [AgGridMixin, ModalFormMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CabeceraAgGridPersonalizada,
  },
  props: {
    gestion: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      agregarDetalle: {
        clasificador_id: null,
        nombre_concepto: '',
        costo: '',
        cantidad: '',
      },
      categoriasItems: [],
      categoria: null,
      verificar: false,
      partida: null,
      partidasItems: [],
      items: [],
      item: [],
      buttonDisabled: true,
      total: 0,
      total_desercion: 0,
      total_gestion: 0,
      total_desercion_gestion: 0,
      concepto_pago: [],
      columnDefs: [
        {
          headerName: 'CUENTA',
          cellRenderer: (params) => {
            return params.data.clasificador_nombre;
          },
          filter: false,
          minWidth: 300,
        },
        {
          headerName: 'CONCEPTO',
          field: 'concepto_pago',
          filter: false,
          minWidth: 120,
        },
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          filter: false,
          minWidth: 120,
        },
        {
          headerName: 'COSTO',
          field: 'costo',
          type: 'numericColumn',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
          editable: function (param) {
            return param.node.rowPinned ? false : true;
          },
          valueFormatter: aMonedaValueFormatter,
          valueParser: costoParser,
          singleClickEdit: true,
        },
        {
          headerName: 'SUBTOTAL',
          field: 'subtotal',
          type: 'numericColumn',
          filter: false,
          minWidth: 130,
          maxWidth: 130,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              const contado = Math.ceil((this.form.cantidad_inscritos_estimada * this.form.porcentaje_contado) / 100);
              const estudiantesContado = conceptosNoPagablesSiEsContado.includes(params.data.concepto_pago)
                ? contado * params.data.costo
                : 0;

              params.data.subtotal =
                params.data.cantidad *
                  params.data.costo *
                  (this.form.cantidad_inscritos_estimada ? this.form.cantidad_inscritos_estimada : 1) -
                estudiantesContado;

              const desertores = Math.ceil((this.form.cantidad_inscritos_estimada * this.form.tasa_desercion) / 100);
              const cantidadInscritos = this.form.cantidad_inscritos_estimada - desertores;

              const desertoresCertificado = conceptosPagosCertificacion.includes(params.data.concepto_pago)
                ? desertores * params.data.costo
                : 0;

              params.data.total =
                (this.form.cantidad_inscritos_estimada ? this.form.cantidad_inscritos_estimada : 1) *
                  params.data.costo +
                (cantidadInscritos ? cantidadInscritos : 1) * (params.data.cantidad - 1) * params.data.costo -
                desertoresCertificado -
                estudiantesContado;

              return params.data.subtotal;
            }
            return params.node.data.subtotal;
          },
        },
        {
          headerName: 'DESERCION',
          field: 'desercion',
          type: 'numericColumn',
          filter: false,
          minWidth: 130,
          maxWidth: 130,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              params.data.desercion = params.data.subtotal - params.data.total;

              return params.data.desercion;
            }

            return params.node.data.desercion;
          },
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          type: 'numericColumn',
          filter: false,
          minWidth: 130,
          maxWidth: 130,
          valueFormatter: aMonedaValueFormatter,
        },

        {
          headerComponent: 'CabeceraAgGridPersonalizada',
          headerComponentParams: () => {
            return {
              contenido: `SUBTOTAL(${this.gestion?.numero})`,
            };
          },
          field: 'subtotal_gestion',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (params) => {
            if (!params.node.rowPinned) {
              const contado = Math.ceil((this.form.cantidad_inscritos_estimada * this.form.porcentaje_contado) / 100);
              const estudiantesContado = conceptosNoPagablesSiEsContado.includes(params.data.concepto_pago)
                ? contado * params.data.costo
                : 0;

              const esCertificado = conceptosPagosCertificacion.includes(params.data.concepto_pago);
              const esContado = conceptosPagosRecurrentes.includes(params.data.concepto_pago);

              let cantidad =
                params.data.cantidad > this.mesesRestantes ? this.mesesRestantes + 1 : params.data.cantidad;

              cantidad = esContado ? (this.mesesRestantes >= 12 ? 1 : cantidad) : cantidad;

              params.data.subtotal_gestion =
                (this.mesesRestantes >= 12 && esCertificado
                  ? 0
                  : esCertificado && this.form.numero_cuotas > this.mesesRestantes + 1
                  ? 0
                  : cantidad) *
                  params.data.costo *
                  (this.form.cantidad_inscritos_estimada ? this.form.cantidad_inscritos_estimada : 1) -
                estudiantesContado;

              const desertores = Math.ceil((this.form.cantidad_inscritos_estimada * this.form.tasa_desercion) / 100);
              const cantidadInscritos = this.form.cantidad_inscritos_estimada - desertores;

              const desertoresCertificado = esCertificado
                ? this.form.numero_cuotas > this.mesesRestantes + 1
                  ? (this.form.cantidad_inscritos_estimada ? this.form.cantidad_inscritos_estimada : 1) *
                      params.data.costo +
                    (cantidadInscritos ? cantidadInscritos : 1) * (cantidad - 1) * params.data.costo
                  : desertores * params.data.costo
                : 0;

              const estudiantesContadoGestion = esContado
                ? contado *
                  (this.mesesRestantes >= 12 && !esCertificado
                    ? this.form.numero_cuotas / 2 - cantidad
                    : this.form.numero_cuotas - cantidad) *
                  params.data.costo
                : 0;

              params.data.subtotal_gestion = params.data.subtotal_gestion + estudiantesContadoGestion;

              params.data.total_gestion =
                this.mesesRestantes >= 12 && esCertificado
                  ? 0
                  : (this.form.cantidad_inscritos_estimada ? this.form.cantidad_inscritos_estimada : 1) *
                      params.data.costo +
                    (cantidadInscritos ? cantidadInscritos : 1) * (cantidad - 1) * params.data.costo -
                    desertoresCertificado -
                    estudiantesContado +
                    estudiantesContadoGestion;

              return params.data.subtotal_gestion;
            }
            return params.node.data.subtotal_gestion;
          },
        },
        {
          headerComponent: 'CabeceraAgGridPersonalizada',
          headerComponentParams: () => {
            return {
              contenido: `DESERCION(${this.gestion?.numero})`,
            };
          },
          field: 'desercion_gestion',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
          valueGetter: (param) => {
            if (!param.node.rowPinned) {
              param.data.desercion_gestion = param.data.subtotal_gestion - param.data.total_gestion;
              return param.data.desercion_gestion;
            }
            return param.node.data.desercion_gestion;
          },
        },
        {
          headerComponent: 'CabeceraAgGridPersonalizada',
          headerComponentParams: () => {
            return {
              contenido: `TOTAL(${this.gestion?.numero})`,
            };
          },
          field: 'total_gestion',
          type: 'numericColumn',
          filter: false,
          minWidth: 140,
          maxWidth: 140,
          valueFormatter: aMonedaValueFormatter,
        },
      ],
    };
  },
  computed: {
    fechaMinSegunda() {
      const fechaInicioClone = moment(this.form.fecha_inicio, 'YYYY-MM-DD');
      fechaInicioClone.add(1, 'months');

      return fechaInicioClone.format('YYYY-MM-DD');
    },
    fechaInicioMoment() {
      return moment(this.form.fecha_segunda, 'YYYY-MM-DD');
    },
    fechaFin() {
      if (!this.form.fecha_inicio || !this.form.numero_cuotas) {
        return null;
      }

      const fechaInicioClone = this.fechaInicioMoment.clone();

      fechaInicioClone.add(this.form.numero_cuotas - 1, 'months');

      if (fechaInicioClone.get('day') == 1) {
        fechaInicioClone.subtract(1, 'days');
      }

      const fechaFin = fechaInicioClone.format('YYYY-MM-DD');

      return fechaFin;
    },
    esAnhoDiferenteFechaSegunda() {
      const anhoInicio = moment(this.form.fecha_inicio).get('year');
      const anhoFin = moment(this.form.fecha_segunda).get('year');
      const diff = anhoFin - anhoInicio;

      return diff > 0;
    },
    mesesRestantes() {
      const mes = this.fechaInicioMoment.get('month') + 1;
      const mesDiciembre = 12;

      return this.esAnhoDiferenteFechaSegunda ? 12 : mesDiciembre - mes + 1;
    },
    pinnedBottomRowData() {
      return [
        {
          desercion: 'SUBTOTAL',
          total: this.sumatoria(),
          total_gestion: this.sumatoria(true),
          bold: true,
        },
        {
          desercion: 'TOTAL DESERCION',
          total: this.total_desercion,
          total_gestion: this.total_desercion_gestion,
          bold: true,
        },
        {
          desercion: 'TOTAL',
          total: this.total,
          total_gestion: this.total_gestion,
          bold: true,
        },
      ];
    },
    estudiantes_desertores() {
      return Math.ceil((this.form.cantidad_inscritos_estimada * this.form.tasa_desercion) / 100);
    },
    estudiantes_contado() {
      return Math.ceil((this.form.cantidad_inscritos_estimada * this.form.porcentaje_contado) / 100);
    },
  },
  created: function () {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  watch: {
    gestion: {
      handler: function () {
        this.gridApi?.refreshHeader();
      },
      deep: true,
      inmediate: true,
    },
    'form.fecha_inicio': function () {
      const fechaInicioClone = moment(this.form.fecha_inicio, 'YYYY-MM-DD');

      fechaInicioClone.add(1, 'months');

      this.form.fecha_segunda = fechaInicioClone.format('YYYY-MM-DD');
      this.errores.fecha_inicio = [];
    },
    'form.fecha_segunda': function () {
      this.errores.fecha_segunda = [];
    },
    'form.categoria_id': function () {
      this.changecantidadIncritosEstimada;
    },
    'form.cantidad_inscritos_estimada': function () {
      this.errores.cantidad_inscritos_estimada = [];
    },
    'form.numero_cuotas': function () {
      this.errores.numero_cuotas = [];
    },
    'form.tasa_desercion': function () {
      this.errores.tasa_desercion = [];
    },
    'form.nombre_programa': function () {
      this.errores.nombre_programa = [];
    },
    'form.porcentaje_contado': function () {
      this.errores.porcentaje_contado = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        sede_id: this.$store.state.CARGO.sede.id,
        gestion_id: this.gestion?.id,
        user_id: this.$store.state.DATA_USER.id,
        sede: this.$store.state.CARGO.sede.nombre,
        user: `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`,
        categoria_id: null,
        categoria: '',
        nombre_programa: '',
        cantidad_inscritos_estimada: '',
        numero_cuotas: '',
        total: 0,
        total_desercion: 0,
        total_gestion: 0,
        total_desercion_gestion: 0,
        fecha_inicio: '',
        fecha_segunda: '',
        fecha_fin: '',
        tasa_desercion: '',
        porcentaje_contado: '',
        detalles_estimaciones: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        sede_id: data.sede_id,
        gestion_id: data.gestion_id,
        user_id: data.user_id,
        sede: data.sede,
        user: data.user,
        categoria_id: data.categoria_id,
        categoria: data.categoria,
        nombre_programa: data.nombre_programa,
        cantidad_inscritos_estimada: data.cantidad_inscritos_estimada,
        numero_cuotas: data.numero_cuotas,
        total: data.total,
        total_desercion: data.total_desercion,
        total_gestion: data.total_gestion,
        total_desercion_gestion: data.total_desercion_gestion,
        fecha_inicio: data.fecha_inicio,
        fecha_segunda: data.fecha_segunda,
        fecha_fin: data.fecha_fin,
        tasa_desercion: data.tasa_desercion,
        porcentaje_contado: data.porcentaje_contado,
        detalles_estimaciones: data.detalles_estimaciones.map((detalle) => ({
          codigo: detalle.codigo,
          concepto_pago: detalle.concepto_pago,
          clasificador_nombre: detalle.clasificador_nombre,
          costo: detalle.costo,
          cantidad: detalle.cantidad,
          subtotal: detalle.subtotal,
          desercion: detalle.desercion,
          total: detalle.total,
          subtotal_gestion: detalle.subtotal_gestion,
          desercion_gestion: detalle.desercion_gestion,
          total_gestion: detalle.total_gestion,
        })),
      };
    },
    changecantidadIncritosEstimada() {
      for (let index = 0; index < this.form.detalles_estimaciones.length; index++) {
        if (conceptosPagosRecurrentes.includes(this.form.detalles_estimaciones[index].concepto_pago)) {
          this.form.detalles_estimaciones[index].cantidad = this.form.numero_cuotas ? this.form.numero_cuotas : 1;
        }
      }

      this.gridApi.refreshCells({ force: true });
    },
    getCategoriaChange() {
      let concepto_pago = [];

      this.form.categoria_id = this.categoria.id;
      this.form.categoria = this.categoria.nombre;

      if (
        [UNIDADES_NEGOCIOS.ESAM, UNIDADES_NEGOCIOS.ESAM_LATAM].includes(this.$store.state.CARGO.sede.unidad_negocio)
      ) {
        if (this.form.categoria.toLowerCase().includes('cursos')) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else {
          const conceptosPagosAceptados = [
            CONCEPTOS_PAGOS.MATRICULA,
            CONCEPTOS_PAGOS.COLEGIATURA,
            CONCEPTOS_PAGOS.CERTIFICACION,
          ];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.DBS) {
        if (this.form.categoria.toLowerCase().includes('cursos')) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else {
          const conceptosPagosAceptados = [
            CONCEPTOS_PAGOS.COLEGIATURA,
            CONCEPTOS_PAGOS.CERTIFICACION,
            CONCEPTOS_PAGOS.CUOTA_INICIAL,
          ];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.CCA) {
        if ([CATEGORIAS.CARRERA_TECNICO_MEDIO, CATEGORIAS.CARRERA_TECNICO_SUPERIOR].includes(this.form.categoria_id)) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDADES, CONCEPTOS_PAGOS.MODALIDAD_TALLER_GRADO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else if (this.form.categoria_id == CATEGORIAS.CURSOS_CAPACITACION) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDADES, CONCEPTOS_PAGOS.CERTIFICACION];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else if (this.form.categoria_id == CATEGORIAS.CURSOS_FORMACION_CONTINUA) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDADES];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else if (this.form.categoria_id == CATEGORIAS.PRE_UNIVERSITARIOS) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSOS_FORMACION_CONTINUA];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.CYBERCORP) {
        if (this.form.categoria_id == CATEGORIAS.SUBSCRIPCION_SIESAM) {
          const conceptosPagosAceptados = [
            CONCEPTOS_PAGOS.SIESAM_MEMBRESIA,
            CONCEPTOS_PAGOS.SIESAM_IMPLEMENTACION,
            CONCEPTOS_PAGOS.SIESAM_MODIFICACIONES,
          ];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.CK) {
        if ([CATEGORIAS.PROGRAMAS, CATEGORIAS.KINDER_CIBERKIDS, CATEGORIAS.INICIAL].includes(this.form.categoria_id)) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDAD];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CIBERKIDS_CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.CAST) {
        const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDADES];

        concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.CCTP) {
        if ([CATEGORIAS.CURSOS_MODULARES, CATEGORIAS.CURSOS_LARGOS].includes(this.form.categoria_id)) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.MENSUALIDADES, CONCEPTOS_PAGOS.CERTIFICACION];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }

        if (this.form.categoria_id == CATEGORIAS.CURSOS_CORTOS) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.ISPI) {
        if (this.form.categoria.toLowerCase().includes('curso')) {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.CURSO];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        } else {
          const conceptosPagosAceptados = [CONCEPTOS_PAGOS.INSCRIPCION, CONCEPTOS_PAGOS.MENSUALIDAD];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      if (this.$store.state.CARGO.sede.unidad_negocio == UNIDADES_NEGOCIOS.UPI) {
        if (!this.form.categoria.toLowerCase().includes('curso')) {
          const conceptosPagosAceptados = [
            CONCEPTOS_PAGOS.INSCRIPCION,
            CONCEPTOS_PAGOS.MATRICULA,
            CONCEPTOS_PAGOS.COLEGIATURA,
            CONCEPTOS_PAGOS.CERTIFICACION,
          ];

          concepto_pago = this.concepto_pago.filter((value) => conceptosPagosAceptados.includes(value.concepto_pago));
        }
      }

      this.form.detalles_estimaciones = [];

      concepto_pago.forEach((concepto) => {
        let cantidad = conceptosPagosRecurrentes.includes(concepto.concepto_pago)
          ? this.form.numero_cuotas
            ? this.form.numero_cuotas
            : 1
          : 1;

        if (
          this.form.detalles_estimaciones.findIndex((detalle) => detalle.concepto_pago == concepto.concepto_pago) == -1
        ) {
          this.form.detalles_estimaciones.push({
            codigo: concepto.cuenta_contable,
            clasificador_nombre: concepto.descripcion_cuenta_contable,
            costo: 1,
            cantidad,
            subtotal: 0,
            desercion: 0,
            total: 0,
            subtotal_gestion: 0,
            desercion_gestion: 0,
            total_gestion: 0,
            concepto_pago: concepto.nombre,
          });
        }
      });
    },
    sumatoria(esGesion = false) {
      let sufijo = '';

      if (esGesion) {
        sufijo = '_gestion';
      }

      let resultado = 0;
      let total = 0;
      let desercion = 0;

      for (let index = 0; index < this.form.detalles_estimaciones.length; index++) {
        resultado = resultado + parseFloat(this.form.detalles_estimaciones[index][`subtotal${sufijo}`]);
        total = total + parseFloat(this.form.detalles_estimaciones[index].total_gestion);
        desercion = desercion + parseFloat(this.form.detalles_estimaciones[index][`desercion${sufijo}`]);
      }

      this.form[`total_desercion${sufijo}`] = desercion.toFixed(2);
      this.form[`total${sufijo}`] = total.toFixed(2);
      this[`total_desercion${sufijo}`] = formatearValorAMoneda(desercion);
      this[`total${sufijo}`] = formatearValorAMoneda(total);

      return formatearValorAMoneda(resultado);
    },
    async abrir(accion, data = []) {
      if (accion == ACCIONES_CRUD.REGISTRAR) {
        this.form = this.generarObjetoFormRegistrar();
        this.categoria = [];
      }

      if (accion == ACCIONES_CRUD.EDITAR) {
        this.form = this.generarObjetoFormEditar(data);
        this.categoria = {
          value: {
            id: data.categoria_id,
            nombre: data.categoria,
          },
          text: data.categoria,
        };
      }

      this.visible = true;
      this.errores = [];

      await this.getConceptosPagos();
      this.getCategorias();
    },
    getCategorias() {
      const unidadNegocioId = this.$store.state.CARGO.sede.unidad_negocio;
      const categorias = this.$store.state.categoria.items;
      this.categoriasItems = categorias
        .map((categoria) => ({
          value: {
            id: categoria.id,
            nombre: categoria.nombre,
          },
          text: categoria.nombre,
          unidad_negocio_id: categoria.unidad_negocio_id,
          desactivado:
            unidadNegocioId == UNIDADES_NEGOCIOS.UPI &&
            [CATEGORIAS.UPI_MAESTRIA, CATEGORIAS.UPI_LICENCIATURA, CATEGORIAS.UPI_TECNICO_UNIVERSITARIO].includes(
              categoria.id,
            ),
        }))
        .filter((categoria) => categoria.unidad_negocio_id == unidadNegocioId);

      if (unidadNegocioId == UNIDADES_NEGOCIOS.CCTP) {
        this.categoriasItems = this.categoriasItems.filter((categoria) =>
          [CATEGORIAS.CURSOS_MODULARES, CATEGORIAS.CURSOS_LARGOS, CATEGORIAS.CURSOS_CORTOS].includes(
            categoria.value.id,
          ),
        );
      }
    },
    agregar() {
      if (this.agregarDetalle.clasificador_id && this.agregarDetalle.costo && this.agregarDetalle.cantidad) {
        const clasificadorId = (obj) => obj.clasificador_id === this.agregarDetalle.clasificador_id.id;
        if (!this.form.detalles_estimaciones.some(clasificadorId)) {
          this.form.detalles_estimaciones.push({
            clasificador_id: this.agregarDetalle.clasificador_id.id,
            clasificador_nombre: this.agregarDetalle.clasificador_id.nombre,
            nombre_concepto: this.agregarDetalle.nombre_concepto,
            costo: this.agregarDetalle.costo,
            cantidad: this.agregarDetalle.cantidad,
            subtotal: (parseFloat(this.agregarDetalle.costo) * parseFloat(this.agregarDetalle.cantidad)).toFixed(2),
            subtotal_gestion: 0,
          });
          this.agregarDetalle = {
            clasificador_id: null,
            nombre_concepto: '',
            costo: '',
            cantidad: '',
          };
          this.gridApi.refreshCells();
        } else {
          this.$notify({
            group: 'notifications',
            title: 'Estimaciones',
            text: 'La cuenta ya se agrego',
            type: 'error',
          });
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Estimaciones',
          text: 'Debe seleccionar una cuenta o llenar todos los campos',
          type: 'error',
        });
      }
    },
    onRowClicked(e) {
      if (e.event.target !== undefined) {
        let rowIndex = e.node.id;
        let actionType = e.event.target.getAttribute('data-action-type');
        switch (actionType) {
          case 'view':
          case 'remove':
            return this.remover(rowIndex);
        }
      }
    },
    remover(index) {
      this.form.detalles_estimaciones.splice(index, 1);
    },
    validar() {
      if (this.form.detalles_estimaciones.length > 0) {
        if (!this.enviando) {
          this.enviando = true;
          if (this.form.id) {
            this.editar();
          } else {
            this.registrar();
          }
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Estimaciones',
          text: 'Debe agregar al menos una cuenta',
          type: 'error',
        });
      }
    },
    async registrar() {
      this.guardar();
    },
    async editar() {
      this.guardar();
    },
    async guardar() {
      this.enviando = true;
      this.errores = [];

      try {
        let response = null;

        if (this.form?.id) {
          response = await IngresoServices.update(this.form.id, this.form);
        } else {
          response = await IngresoServices.store(this.form);
        }

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.errores = errores;
        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
    async getConceptosPagos() {
      this.concepto_pago = [];

      await axios
        .get(
          `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio?unidad_negocio=${this.$store.state.CARGO.sede.unidad_negocio}`,
        )
        .then((response) => {
          const conceptos = response.data.data.map((concepto) => ({
            nombre: concepto.concepto_pago.nombre,
            opcional: concepto.concepto_pago.opcional,
            cuenta_contable: concepto.cuenta_contable,
            descripcion_cuenta_contable: concepto.descripcion_cuenta_contable,
            concepto_pago_id: concepto.concepto_pago.id,
            concepto_pago: concepto.concepto_pago.nombre,
          }));

          this.concepto_pago = conceptos;
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};

function costoParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  }

  return params.data.costo;
}
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.v-dialog {
  align-items: flex-start;
}

.ag-grid-table-presupuesto-partida {
  height: calc(var(--vh, 1vh) * 100 - 28rem);
}
</style>

<style scoped>
hr {
  margin-top: 8px;
  margin-bottom: 10px;
  border: 0;
  border-top: 1px solid #eee;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .container,
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}

::v-deep .container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
}
</style>

<style>
.mood {
  border-radius: 15px;
  border: 1px solid grey;
  background: #e6e6e6;
  padding: 15px;
  text-align: center;
  display: inline-block;
  outline: none;
}

.default {
  border: 1px solid transparent !important;
  padding: 4px;
}

.selected {
  border: 1px solid lightgreen !important;
  padding: 4px;
}

.simple-input-editor {
  width: 100%;
  height: 100%;
}
</style>